// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // firebase: {
  //   apiKey: "AIzaSyBOiJv_4fnDE_LXb3UKWO792_wt3YDYrfo",
  //   authDomain: "mobitrix-web.firebaseapp.com",
  //   databaseURL: "https://mobitrix-web.firebaseio.com",
  //   projectId: "mobitrix-web",
  //   storageBucket: "mobitrix-web.appspot.com",
  //   messagingSenderId: "1027135256757",
  //   appId: "1:1027135256757:web:2ad132193392079f8b66fc",
  //   vapId: "BKElmlxJSoDV_HhCqVJgr-AgswBw3nanp4O-reMl1aunVZItYCsQ5A4GIfbxj_qjLgkenNwnFZ_8zhU2OKzcCVs",
  // },
  // serviceWorkerScript: "src/firebase-messaging-sw.js",


  // version: require("../../package.json").version,
  //For 1bakeshop.com
  // production: true,
  // webApiUrl: "/mobitrixcartserver/",
  // redirectUri: "https://1bakeshop.com/implicit/callback",

  //For Local
  // production: false,
  // cartApiUrl: 'http://localhost:8000/mobitrixcartserver/',
  // apiUrl: 'http://localhost:8000/mobitrixserver/',
  // oldApiUrl: 'http://localhost:8000/mobitrixserverold/',
  // redirectUri: "http://localhost:4200/implicit/callback",
  // pythonApiUrl: "http://143.110.180.52:8679/",

  //For Local Server
  production: false,
  // cartApiUrl: "http://192.168.2.31:8000/mobitrixcartserver/",
  // apiUrl: 'http://192.168.2.31:8000/mobitrixserver/',
  // oldApiUrl: 'http://192.168.2.31:8000/mobitrixserverold/',
  // redirectUri: "http://192.168.2.31:8000/implicit/callback",


  // googleRedirectUrl: "http://localhost:4200",
  // googleClientId: "1027135256757-9t4carlh4l1e9tqh500ihenulgcsjon3.apps.googleusercontent.com"

  // source: "http://localhost:4200/login",
  // logoutSource: "http://localhost:4200/",
  // loginLogoutUrl: "https://authlogin.mobitrix.net/api/v1/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
